import $ from "jQuery";

// Selected Bootstrap JavaScript imports go here
import "bootstrap/js/dist/util.js";
import "bootstrap/js/dist/collapse.js";

// import { runSwiper } from "components/swiper.js";
import { navigationToggle } from "components/nav.js";
import skipLinks from "components/skipLinks";

// Assign jQuery to the window for convenience
window.$ = $;
window.jQuery = $;

$(document).ready(function() {
  // runSwiper();
  skipLinks();
  navigationToggle();
});
